import {
  ERegistrationDocumentStatus,
  ERegistrationDocumentType,
  IRegistration,
} from "@rentiohq/shared-frontend/dist/types/registration.types";

export const isContractRegistrationPending = (registration: IRegistration) => {
  const rentRegistrationDocuments = registration?.documents;

  const contractDocument = rentRegistrationDocuments?.find(
    document => document?.documentType === ERegistrationDocumentType.Contract,
  );

  const propertyInspectionDocument = rentRegistrationDocuments?.find(
    document =>
      document?.documentType ===
      ERegistrationDocumentType.PropertyInspectionReport,
  );

  const contractDocumentStatus =
    contractDocument?.status || ERegistrationDocumentStatus.None;
  const propertyInspectionDocumentStatus =
    propertyInspectionDocument?.status || ERegistrationDocumentStatus.None;

  const documentStatuses = [
    contractDocumentStatus,
    propertyInspectionDocumentStatus,
  ];

  return documentStatuses.includes(ERegistrationDocumentStatus.Registering);
};

export const isAddendumRegistrationPending = (registration: IRegistration) => {
  const rentRegistrationDocuments = registration?.documents;

  const addendumDocumentStatuses = rentRegistrationDocuments
    ?.filter(
      document => document?.documentType === ERegistrationDocumentType.Addendum,
    )
    .map(document => document.status);

  return addendumDocumentStatuses.includes(
    ERegistrationDocumentStatus.Registering,
  );
};
